import { render, staticRenderFns } from "./LegalPersons.vue?vue&type=template&id=18faaa75&scoped=true&"
import script from "./LegalPersons.vue?vue&type=script&lang=js&"
export * from "./LegalPersons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18faaa75",
  null
  
)

export default component.exports